import { Checkbox, Form, Select, Space } from "antd";
import { getConfigAppPartType } from "../../utils";
import { AppPartType } from "../../AppForm/types";
import { Styles } from "./styled";
interface IProps {
  isDisable?: boolean;
  preview?: boolean;
  item: AppPartType;
  parentItem?: AppPartType;
  style?: React.CSSProperties;
  isTable?: boolean;
  nameItem: string;
  styleColor?: React.CSSProperties;
  className?: string;
}

const CheckBox = (props: IProps) => {
  const {
    item,
    isDisable,
    style,
    nameItem,
    preview,
    isTable,
    styleColor = {},
    className,
  } = props;
  const { isHiddenLabel, labelText } = getConfigAppPartType(item);
  const form = Form.useFormInstance();
  const value = form.getFieldValue(nameItem);
  const isShowOnlyValue = !preview && isTable && isDisable;
  return (
    <Styles
      style={{ ...styleColor, ...style }}
      id={item.id}
      className="check-box"
      color={styleColor?.color}
      background={styleColor?.background}
    >
      <div className="value_text_container">{isShowOnlyValue && value}</div>
      <Form.Item
        hidden={isShowOnlyValue}
        label={
          isHiddenLabel ? (
            <div></div>
          ) : (
            <div className="no-wrap-text" title={labelText}>
              {labelText}
            </div>
          )
        }
        name={nameItem}
        rules={[
          {
            required: item.is_required_field,
            message: `必須項目です`,
          },
        ]}
        className={className}
      >
        <Checkbox.Group>
          <Space
            direction={(item.item_config_data?.layout as any) || "horizontal"}
          >
            {(item.item_config_data?.options || []).map((option, i) => {
              return (
                <Checkbox key={i} value={option.text}>
                  {option.text}
                </Checkbox>
              );
            })}
          </Space>
        </Checkbox.Group>
      </Form.Item>
      {item.is_required_field && value?.length === 0 && (
        <p className="checkbox-explain-error">必須項目です</p>
      )}
    </Styles>
  );
};
export default CheckBox;
